import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from '#app/components/ui/icon'
import { Input } from '#app/components/ui/input'
import { cn } from '#app/utils/misc'

interface NewSearchStoreInputProps {
	onSearch: (searchTerm: string) => void
}

const NewSearchStoreInput: React.FC<NewSearchStoreInputProps> = ({
	onSearch,
}) => {
	const [searchTerm, setSearchTerm] = useState('')
	const { t } = useTranslation('product_details_page')

	const handleSearch = () => {
		onSearch(searchTerm)
	}

	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') {
			handleSearch()
		}
	}

	return (
		<div className="relative flex w-full items-center rounded-lg">
			<Icon className="absolute left-4" size="lg" name="magnifying-glass" />
			<Input
				type="text"
				name="terms"
				placeholder={t('search_for_a_store')}
				value={searchTerm}
				onChange={e => setSearchTerm(e.target.value)}
				onKeyDown={handleKeyDown}
				className={cn(
					'w-full rounded-lg h-10 border border-beige-90 border-input bg-white pl-10 pr-6 ring-offset-background placeholder:text-muted-foreground placeholder:opacity-20 focus:outline focus:outline-1 focus:outline-transparent',
				)}
			/>
		</div>
	)
}

export default NewSearchStoreInput
